import { render } from "./NuevoRegistroModal.vue?vue&type=template&id=5c039bf9&scoped=true"
import script from "./NuevoRegistroModal.vue?vue&type=script&lang=js"
export * from "./NuevoRegistroModal.vue?vue&type=script&lang=js"

import "./NuevoRegistroModal.vue?vue&type=style&index=0&id=5c039bf9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c039bf9"]])

export default __exports__